import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faEnvelope, faGraduationCap } from "@fortawesome/pro-solid-svg-icons";
import Title from "components/listViewTemplates/title/Title";

import styles from "./ScheduleTitle.module.scss";

interface Props {
  title: string;
  hasConsumableItems: boolean;
  canAutoStart: boolean;
}

export const ScheduleTitle = (props: Props) => {
  const { title, hasConsumableItems, canAutoStart } = props;

  const showEnvelope = !hasConsumableItems || canAutoStart;
  const showCap = hasConsumableItems;

  return (
    <div className={styles.titleBlock}>
      <Title className="normal-color" title={title} />
      <div className={styles.iconRow}>
        {showEnvelope && <FontAwesomeIcon className={styles.icon} icon={faEnvelope} />}
        {showCap && <FontAwesomeIcon className={styles.icon} icon={faGraduationCap} />}
      </div>
    </div>
  );
};
